var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-address"},[_c('div',{staticClass:"title"},[_vm._v("填写收货信息后，便于后续奖品的发放")]),_vm._v(" "),_c('lAddress',{attrs:{"success":_vm.success}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }